<template>
    <button class="hamburger hidden-md-up js-ga-event"
            :class="{ open: isOpen }"
            @click="handleClick"
            data-page-area="hamburger"
            data-type="button"
            data-name="hamburger"
    >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </button>
</template>

<script>

import { ref, inject, onMounted } from 'vue'

export default {

    setup() {

        const isOpen  = ref(false)
        const emitter = inject('emitter')

        onMounted( () => {
            emitter.on('menu-closed', () => isOpen.value = false)
        })

        function handleClick() {
            isOpen.value = !isOpen.value
            emitter.emit('menu-open', isOpen.value)
        }

        return {
            isOpen,
            handleClick
        }
    }
}
</script>
